var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.searchResultVariants && _vm.searchResultVariants.length)?_c('div',{staticClass:"search-result-grid"},[_vm._l((_vm.searchResultVariants),function(ref){
    var image = ref.image;
    var productName = ref.productName;
    var variantName = ref.variantName;
    var originalQuantity = ref.originalQuantity;
    var isFavorite = ref.isFavorite;
    var productId = ref.productId;
    var variantId = ref.variantId;
    var trackInventory = ref.trackInventory;
    var inStock = ref.inStock;
    var inventoryQuantity = ref.inventoryQuantity;
    var increment = ref.increment;
    var minimum = ref.minimum;
    var price = ref.price;
    var deleted = ref.deleted;
return [_c('reorder-variant-tile',{attrs:{"image":image,"product-name":productName,"product-id":productId,"variant-id":variantId,"is-favorite":isFavorite,"variant-name":variantName,"original-quantity":originalQuantity,"track-inventory":trackInventory,"in-stock":inStock,"inventory-quantity":inventoryQuantity,"increment":increment,"minimum":minimum,"price":price,"deleted":deleted}})]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }